var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "05_PresentaitonFlow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A_01",
    transform: "translate(-992.000000, -1454.000000)",
    fill: "#129FA9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(95.000000, 1127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron/Primary",
    transform: "translate(897.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "9 14.2421255 0 4.24244558 0.71446863 3.6 9 12.8055058 17.2855314 3.6 18 4.24244558"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronGreen);
export default __webpack_public_path__ + "static/media/chevron_green.12875ab79d5ea46e291d7533cfeba92f.svg";
export { ForwardRef as ReactComponent };